import { useTranslation } from '@/contexts/i18n-context';
import { UserEntryLayout } from '@/components/auth/user-entry-layout';
import { UserEntrySuccessCard } from '@/components/auth/user-entry-success-card';
import { useSearchParams } from '@/util/react-router-dom';
import styles from './username-restoration-success-page.module.css';
import { EmailSvg } from '@/components/svgs/email';

export function UsernameRestorationSuccessPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  return (
    <UserEntryLayout>
      <UserEntrySuccessCard
        title={t('usernameRestoration.success.title')}
        subtitle={t('usernameRestoration.success.description', {
          email: <strong key="email">{searchParams.get('email')}</strong>,
        })}
        icon={<EmailSvg className={styles.icon} />}
        hasLoginButton
      />
    </UserEntryLayout>
  );
}
